import React, { forwardRef,useRef } from 'react'
import { Input } from 'antd'
import { uuid } from '../../../../utils'

const { TextArea } = Input

const DiscardReason = forwardRef((props, ref) => {
    const textAreaRef = useRef();
    const { data, isEdit, callBack } = props;

    return (
        <div>
            {!isEdit ? data.text ? <div>
                <div style={{ margin: "10px 0" }}>
                    {data.label}
                </div>
                <TextArea value={data.text} key={uuid()} placeholder={"请输入"} maxLength={200} rows={2} style={{ width: 350, height: 64, fontSize: 14 }} ref={textAreaRef} />
            </div>:"" : <div>
                <div style={{ margin: "10px 0" }}>
                    {data.label}
                </div>
                <TextArea onChange={(e) => {
                    callBack && callBack({ value: e.target.value, type: props.data.value })
                }} key={uuid()} placeholder={"请输入"} maxLength={200} rows={2} style={{ width: 350, height: 64, fontSize: 14 }} ref={textAreaRef} />
            </div>}
        </div>
    )
})

export default DiscardReason